(function () {
  function initCarousel(carousel) {
    if (!carousel || carousel.dataset.inited === 'true') return;
    carousel.dataset.inited = 'true';

    var section = carousel.closest('[id^="shopify-section-"]') || document;
    var viewport = carousel.querySelector('[data-swiper-viewport]');
    var track = carousel.querySelector('[data-swiper-track]');
    var slides = carousel.querySelectorAll('[data-swiper-slide]');
    var prevBtn = carousel.querySelector('[data-swiper-prev]');
    var nextBtn = carousel.querySelector('[data-swiper-next]');
    var dotsWrap = section.querySelector('[data-swiper-dots]');
    var dots = dotsWrap ? dotsWrap.querySelectorAll('[data-swiper-dot]') : [];
    var index = 0;
    var desktopMedia = window.matchMedia('(min-width: 1280px)');

    function setDotState(activeIndex) {
      if (!dots.length) return;
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === activeIndex);
      });
    }

    function setArrowState(activeIndex) {
      if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = activeIndex <= 0;
      nextBtn.disabled = activeIndex >= slides.length - 1;
    }

    function syncDesktopPosition(withTransition) {
      if (!slides.length) return;
      
      if (!withTransition) {
        // 无动画，直接设置状态
        slides.forEach(function (slide, slideIndex) {
          slide.style.transition = 'none';
          slide.classList.toggle('is-active', slideIndex === index);
        });
        return;
      }
      
      // 有动画，先移除所有 active，然后添加新的 active
      slides.forEach(function (slide, slideIndex) {
        if (slideIndex === index) {
          // 目标 slide：渐显
          slide.style.transition = 'opacity 0.3s ease-out, visibility 0s linear 0s, z-index 0s linear 0s';
          slide.classList.add('is-active');
        } else if (slide.classList.contains('is-active')) {
          // 当前 active 的 slide：渐隐
          slide.style.transition = 'opacity 0.3s ease-in, visibility 0s linear 0.3s, z-index 0s linear 0.3s';
          slide.classList.remove('is-active');
        }
      });
    }

    function syncMobilePosition(behavior) {
      if (!viewport) return;
      viewport.scrollTo({
        left: Math.round(index * viewport.clientWidth),
        behavior: behavior || 'smooth'
      });
    }

    function goToSlide(nextIndex, options) {
      if (!slides.length) return;
      var clamped = Math.max(0, Math.min(nextIndex, slides.length - 1));
      index = clamped;
      setDotState(index);
      setArrowState(index);
      if (desktopMedia.matches) {
        syncDesktopPosition(!(options && options.instant));
      } else {
        syncMobilePosition(options && options.instant ? 'auto' : 'smooth');
      }
    }

    function handleResize() {
      goToSlide(index, { instant: true });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToSlide(index - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToSlide(index + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var dotIndex = Number(dot.getAttribute('data-index'));
        goToSlide(dotIndex);
      });
    });

    if (viewport) {
      var ticking = false;
      viewport.addEventListener(
        'scroll',
        function () {
          if (desktopMedia.matches || ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            var width = viewport.clientWidth || 1;
            var scrolledIndex = Math.round(viewport.scrollLeft / width);
            if (scrolledIndex !== index) {
              index = Math.max(0, Math.min(scrolledIndex, slides.length - 1));
              setDotState(index);
            }
            ticking = false;
          });
        },
        { passive: true }
      );
    }

    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', handleResize);
    } else if (desktopMedia.addListener) {
      desktopMedia.addListener(handleResize);
    }
    window.addEventListener('resize', handleResize);
    
    // 初始化时设置第一个 slide 为 active
    if (slides.length > 0) {
      slides[0].classList.add('is-active');
    }
    goToSlide(0, { instant: true });
  }

  function initAll(scope) {
    var root = scope || document;
    var carousels = root.querySelectorAll('[data-custom-swiper]');
    carousels.forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initAll(event.target);
  });
})();